import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { Text } from 'foundations-components/components/Text';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OverviewSectionHeader = ({
  title,
  description,
  button
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: "space-between",
    marginBlockEnd: "200",
    children: [/*#__PURE__*/_jsxs(Box, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: isMobile ? 'h4' : 'h2',
        marginBlockEnd: "200",
        children: title
      }), /*#__PURE__*/_jsx(Text, {
        as: "p",
        marginBlockEnd: "200",
        children: description
      })]
    }), /*#__PURE__*/_jsx(Box, {
      children: button
    })]
  });
};
export default OverviewSectionHeader;